export interface ITranscription {
  jobName: string;
  accountId: string;
  results: ITranscriptionResult;
  status: string;
}

export class Transcription implements ITranscription {
  jobName: string = '';
  accountId: string = '';
  results: ITranscriptionResult = new TranscriptionResult();
  status: string = '';

  constructor(configOverride?: Partial<ITranscription>) {
    if (configOverride) {
      Object.assign(this, configOverride);
    }
  }
}

export interface ITranscriptionResult {
  transcripts: ITranscriptList[];
  items: ITranscriptItem[];
}

export class TranscriptionResult implements ITranscriptionResult {
  transcripts: ITranscriptList[] = [];
  items: ITranscriptItem[] = [];

  constructor(configOverride?: Partial<ITranscriptionResult>) {
    if (configOverride) {
      Object.assign(this, configOverride);
    }
  }
}

export interface ITranscriptList {
  transcript: string;
  confidence?: number;
}

export class TranscriptList implements ITranscriptList {
  transcript: string = '';
  confidence?: number = 0;

  constructor(configOverride?: Partial<ITranscriptList>) {
    if (configOverride) {
      Object.assign(this, configOverride);
    }
  }
}

export interface ITranscriptItem {
  start_time?: string;
  end_time?: string;
  alternatives: ITranscriptAlternative[];
  type?: string;
}

export class TranscriptItem implements ITranscriptItem {
  /* tslint:disable:variable-name */
  start_time?: string = '';
  end_time?: string = '';
  alternatives: ITranscriptAlternative[] = [];
  type?: string = '';

  constructor(configOverride?: Partial<ITranscriptItem>) {
    if (configOverride) {
      Object.assign(this, configOverride);
    }
  }
}

export interface ITranscriptAlternative {
  confidence: string;
  content: string;
}

export class TranscriptAlternative implements ITranscriptAlternative {
  confidence: string = '';
  content: string = '';

  constructor(configOverride?: Partial<ITranscriptAlternative>) {
    if (configOverride) {
      Object.assign(this, configOverride);
    }
  }
}

export interface ITranscriptWord {
  id: number;
  start: string;
  end: string;
  content: string;
  isBold: boolean;
  isItalicized: boolean;
  isBlue: boolean;
  isHighlighted: boolean;
  hasHeader: boolean;
  hasNewline: boolean;
}

export class TranscriptWord implements ITranscriptWord {
  id: number = 0;
  start: string = '';
  end: string = '';
  content: string = '';
  isBold: boolean = false;
  isItalicized: boolean = false;
  isBlue: boolean = false;
  isHighlighted: boolean = false;
  hasHeader: boolean = false;
  hasNewline: boolean = false;

  constructor(configOverride?: Partial<ITranscriptWord>) {
    if (configOverride) {
      Object.assign(this, configOverride);
    }
  }
}

export interface IFormattedTranscriptWord {
  isBold: boolean;
  isBlue: boolean;
  isHighlighted: boolean;
  isItalicized: boolean;
  hasHeader: boolean;
  hasNewline: boolean;
  wordList: ITranscriptWord[];
}

export class FormattedTranscriptWord implements IFormattedTranscriptWord {
  isBold: boolean = false;
  isBlue: boolean = false;
  isHighlighted: boolean = false;
  isItalicized: boolean = false;
  hasHeader: boolean = false;
  hasNewline: boolean = false;
  wordList: ITranscriptWord[] = [];

  constructor(configOverride?: Partial<IFormattedTranscriptWord>) {
    if (configOverride) {
      Object.assign(this, configOverride);
    }
  }
}
